var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"loadComponent"}},[_c(_setup.computeNameComponent,{key:_vm.$route.name,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }